export const SectionTitle = ({ eyebrow, title, sub, align = "left", light = false, as: H = "h2", id }) => (
  <div className={`mb-10 max-w-2xl lg:mb-14 ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && <span className={`eyebrow ${light ? "!text-gold-light" : ""}`}>{eyebrow}</span>}
    <H id={id} className={`mt-4 text-2xl font-semibold leading-tight sm:text-3xl lg:text-4xl ${light ? "text-white" : "text-emerald-950"}`}>{title}</H>
    {sub && <p className={`mt-4 text-base leading-relaxed md:text-lg ${light ? "text-white/75" : "text-ink/65"}`}>{sub}</p>}
  </div>
);
